import { render } from "./MessagePopup.vue?vue&type=template&id=4af61f1a"
import script from "./MessagePopup.vue?vue&type=script&lang=js"
export * from "./MessagePopup.vue?vue&type=script&lang=js"

import "./MessagePopup.vue?vue&type=style&index=0&id=4af61f1a&lang=css"
script.render = render

export default script